module.exports = __webpack_public_path__ + "img/action-btn.7ff59ed9.png";